<!-- 生活缴费 -->
<template>
  <div>
    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img v-if="orderInfo.payType=='alipay'" src="/imgs/title_zfb.jpg" />
        <img v-if="orderInfo.payType=='weixin'" src="/imgs/title_wx.jpg" />
        <img v-if="orderInfo.payType=='douyin'" src="/imgs/title_douyin.png" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- 付款流程 -->
    <div class="pannel">
      <div class="pay-flow" v-if="orderInfo.payType=='alipay'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开支付宝APP；</p>
        <p class="no">2、首页选择<span style="color:red;">生活缴费</span>入口；</p>
        <p class="no">3、选择<span style="color:red;">新增缴费户号</span>并选择<span style="color:red;">电费</span>；</p>
        <p class="no">4、切换<span style="color:red;">城市</span>并选择相应的<span style="color:red;">缴费单位</span>，黏贴复制的<span style="color:red;">户号</span>和<span style="color:red;">金额</span>；</p>
      </div>
      <div class="pay-flow" v-if="orderInfo.payType=='weixin'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开微信APP</p>
        <p class="no">2、<span style="color:red;">我->服务->生活缴费</span>点击进入；</p>
        <p class="no">3、点击<span style="color:red;">电费</span>模块，选择<span style="color:red;">缴费单位，</span>切换<span style="color:red;">城市</span>，填写<span style="color:red;">户号，金额</span></p>
      </div>
    </div>

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- 复制区域 -->
    <div class="pannel" v-if="orderInfo.orderId">
      <!-- 复制 -->
      <div style="padding-bottom:0.5em;">
        <table class="details" style="">
          <tr v-if="orderInfo.payType=='weixin'">
            <td></td>
            <td>
              <span style="color: blue;">{{orderInfo.prov}}电费</span>
            </td>
          </tr>
          <tr>
            <td>缴费单位：</td>
            <td>
              <span style="color: blue;">{{orderInfo.powerCompName}}</span>
            </td>
          </tr>
          <tr>
            <td>城市：</td>
            <td>
              <span v-if="copyCityIf" style="color: green;">{{orderInfo.city}}</span>
              <span v-else style="color: blue;">{{orderInfo.city}}</span>
              <button v-on:click="copyCity" class="btn copy" v-if="orderInfo.paykind==0">复制城市</button>
            </td>
          </tr>
          <tr>
            <td>缴费户号：</td>
            <td>
              <span v-if="copyDoorIf" style="color: green;">{{orderInfo.doorNum}}</span>
              <span v-else style="color: blue;">{{orderInfo.doorNum}}</span>
              <button v-on:click="copyDoor" class="btn copy" v-if="orderInfo.paykind==0">复制户号</button>
            </td>
          </tr>
          <tr>
            <td>缴费金额：</td>
            <td>
              <span v-if="cptyAmountIf" style="color: green;"><b>{{orderInfo.amount}}</b></span>
              <span v-else style="color: red;"><b>{{orderInfo.amount}}</b></span>
              <button @click="copyAmount" class="btn copy" v-if="orderInfo.paykind==0">复制金额</button>
            </td>
          </tr>
        </table>
      </div>
      <!--支付宝唤醒按钮-->
      <div style="padding-bottom:0.5em;" v-if="orderInfo.paykind==1">
        <div style="text-align:center;">
          <a :href="orderInfo.alipUrl" class="btn btn-alip" style="width: 70%;">快速打开支付宝</a>
        </div>
      </div>
      <!--二维码-->
      <div style="padding-bottom:0.5em;" v-if="orderInfo.paykind==2">
        <table style="">
          <tr>
            <td style="width: 50%;">
              <div>
                <img :src="orderInfo.alipQrURL" style="margin: 0 auto;width: 80%;" />
              </div>
            </td>
            <td style="width: 50%;">
              <div class="pay-flow" style="font-size: 0.8em;">
                <p class="no">1、下载保存二维码图片</p>
                <p class="no">2、手动打开支付宝APP</p>
                <p class="no">3、点击右上角扫一扫，选择二维码</p>
              </div>
              <div class="pannel-btn">
                <a class="btn down" :href="orderInfo.alipQrURL" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`" style="padding:0.4em;">下载</a>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!--演示视频-->
    <div class="pannel-simp title">
      <div style="text-align:center;" v-if="orderInfo.payType=='alipay' && showVideo">
        <video id="video1" width="90%;" style="margin-top:5px;" muted controls preload="auto" autoplay="autoplay" data-setup="{'autoplay':true}" loop>
          <source src="/imgs/zfb01.mp4" type="video/mp4" v-if="orderInfo.alipAuto" />
          <source src="/imgs/zfb02.mp4" type="video/mp4" v-else />
        </video>
      </div>
      <div style="text-align:center;" v-if="orderInfo.payType=='weixin' && showVideo">
        <video id="video1" width="90%;" style="margin-top:5px;" muted controls preload="auto" autoplay="autoplay" data-setup="{'autoplay':true}" loop>
          <source src="/imgs/wx01.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="">
        <button class="btn video" style="width:80%;" @click="showVideo=!showVideo" v-if="!showVideo">显示支付流程视频</button>
      </div>
    </div>

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">超时支付，修改金额，修改支付方式，重复支付，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">次日前未查，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：支付成功确认时间<span style="color: red;">5-10分钟</span>,付款后<span style="color: red;">超过10分钟</span>还未到账,请联系客服查单补单!
      </p>
    </div>
    <div class="pannel-simp attention" style="margin-bottom: 100px;"></div>

    <!-- 弹出框2 -->
    <div class="vdf-modal" v-if="showCopy">
      <div class="vdf-modal-content">
        复制成功
      </div>
    </div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    alipInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      copyCityIf: false,
      copyDoorIf: false,
      cptyAmountIf: false,
      //
      showVideo: false, //显示视频
      //
      showCopy: false, // 弹框
    };
  },
  computed: {},
  created() {},
  methods: {
    // 复制城市
    copyCity: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.city,
        3,
        () => {
          this.copyCityIf = true;
          this.showCopy = true;
          setTimeout(() => {
            this.showCopy = false;
          }, 1000);
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制户号
    copyDoor: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.doorNum,
        1,
        () => {
          this.copyDoorIf = true;
          this.showCopy = true;
          setTimeout(() => {
            this.showCopy = false;
          }, 1000);
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.cptyAmountIf = true;
          this.showCopy = true;
          setTimeout(() => {
            this.showCopy = false;
          }, 1000);
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
